import * as Lazy from './quizRoutes.lazy';

/**
 * Quiz routes with lazy loading
 */
const quizRoutes = [
  {
    public: true,
    path: '/quiz',
    renderer: (props) => <Lazy.QuizHub {...props} />
  },
  {
    public: true,
    path: '/quiz/bettor-type',
    renderer: (props) => <Lazy.BettorTypeQuiz {...props} />
  },
  {
    public: true,
    path: '/quiz/bettor-type/result/:archetype',
    renderer: (props) => <Lazy.BettorTypeResult {...props} />
  }
];

export default quizRoutes;
